import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "searchContainer",
    "searchInput",
    "results",
    "confirmContainer",
    "confirmName",
    "confirmEmail",
    "sourceIdField"
  ]
  static values = { url: String, targetId: String }

  connect() {
    this.timeout = null
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  showSearch() {
    this.searchContainerTarget.style.display = 'block'
    this.searchInputTarget.focus()
  }

  hideSearch() {
    this.searchContainerTarget.style.display = 'none'
    this.searchInputTarget.value = ''
    this.clearResults()
    this.confirmContainerTarget.style.display = 'none'
  }

  handleInput() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    const query = this.searchInputTarget.value.trim()

    if (query.length < 2) {
      this.clearResults()
      return
    }

    this.timeout = setTimeout(() => {
      this.search(query)
    }, 300)
  }

  async search(query) {
    try {
      const url = `${this.urlValue}?query=${encodeURIComponent(query)}&target_id=${encodeURIComponent(this.targetIdValue)}`
      const response = await fetch(url)
      const results = await response.json()
      this.displayResults(results)
    } catch (error) {
      console.error('Member search error:', error)
      this.clearResults()
    }
  }

  displayResults(results) {
    this.resultsTarget.replaceChildren()

    if (results.length === 0) {
      const empty = document.createElement('div')
      empty.className = 'list-group-item text-muted'
      empty.textContent = 'No members found'
      this.resultsTarget.appendChild(empty)
      return
    }

    results.forEach(result => {
      const item = document.createElement('button')
      item.type = 'button'
      item.className = 'list-group-item list-group-item-action'

      const wrapper = document.createElement('div')
      wrapper.className = 'd-flex justify-content-between align-items-center'

      const content = document.createElement('div')
      const nameEl = document.createElement('strong')
      nameEl.textContent = result.name
      content.appendChild(nameEl)

      content.appendChild(document.createElement('br'))
      const detailEl = document.createElement('small')
      detailEl.className = 'text-muted'
      detailEl.textContent = `${result.email} · Member since ${result.member_since}`
      content.appendChild(detailEl)

      wrapper.appendChild(content)
      item.appendChild(wrapper)
      item.addEventListener('click', () => this.selectMember(result))
      this.resultsTarget.appendChild(item)
    })
  }

  selectMember(member) {
    this.sourceIdFieldTarget.value = member.id
    this.confirmNameTarget.textContent = member.name
    this.confirmEmailTarget.textContent = member.email
    this.confirmContainerTarget.style.display = 'block'
    this.clearResults()
    this.searchInputTarget.value = ''
  }

  clearResults() {
    this.resultsTarget.replaceChildren()
  }
}
